export const GET_FLAT_DEALS_TRADES = 'api/eu/v1/Inbox/get-deal-inbox';
export const GET_FLEX_DEALS = 'api/eu/v1/Inbox/get-flex-inbox';
export const GET_FLEX_MESSAGE_BLOCKS = 'api/eu/v1/Inbox/get-flex-message-block';
export const GET_EXTERNAL_INBOX = 'api/eu/v1/ExternalInbox/get-external-inbox';
export const GET_EXTERNAL_INBOX_BLOCK = 'api/eu/v1/ExternalInbox/get-external-inbox-block';
export const GET_FLAT_DEAL_PROFILES = 'api/eu/v1/Inbox/get-flat-deal-leg-profiles';
export const SET_FLATDEAL_IGNORE = 'api/eu/v1/Inbox/set-flatdeal-ignore';
export const SET_FLATDEAL_REIMPORT = 'api/eu/v1/Inbox/set-flatdeal-reimport';
export const GET_MARKETS = 'api/eu/v1/Market/get';
export const DOWNLOAD_MARKETS = '/api/eu/v1/Market/download';
export const DOWNLOAD_ORGANIZATIONS = '/api/eu/v1/Organization/download';
export const DOWNLOAD_NOMINATION_GROUPS = '/api/eu/v1/NominationGroup/download';
export const DOWNLOAD_LOCATIONS = '/api/eu/v1/Location/download';
export const DOWNLOAD_CONTRACTS = '/api/eu/v1/Contract/download';
export const DOWNLOAD_MASTER_DATA = '/api/eu/v1/Export/download-masterdata';
export const GET_MARKET_POSITION_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/MarketPosition/get-by-hour',
  date: 'api/eu/v1/TimeSeries/MarketPosition/get-by-date',
  month: 'api/eu/v1/TimeSeries/MarketPosition/get-by-month',
};
export const SEARCH_MARKET_POSITION_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/MarketPosition/search-by-hour',
  date: 'api/eu/v1/TimeSeries/MarketPosition/search-by-date',
  month: 'api/eu/v1/TimeSeries/MarketPosition/search-by-month',
};
export const GET_MARKET_POSITION_DEALS = 'api/eu/v1/Deals/get';
export const GET_NOMINATION_GROUPS = 'api/eu/v1/NominationGroup/get';
export const GET_CONTRACT_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/Contract/get-by-hour',
  date: 'api/eu/v1/TimeSeries/Contract/get-by-date',
  month: 'api/eu/v1/TimeSeries/Contract/get-by-month',
};
export const SEARCH_CONTRACT_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/Contract/search-by-hour',
  date: 'api/eu/v1/TimeSeries/Contract/search-by-date',
  month: 'api/eu/v1/TimeSeries/Contract/search-by-month',
};
export const GET_TIME_SERIES_VIEWS = 'api/eu/v1/TimeSeries/View/get';
export const TIME_SERIES_VIEW_IDS = {
  MARKET_POSITION: 1,
  CONTRACT: 2,
  BALANCES: 3,
} as const;
export const GET_BALANCE_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/Balance/get-by-hour',
  date: 'api/eu/v1/TimeSeries/Balance/get-by-date',
  month: 'api/eu/v1/TimeSeries/Balance/get-by-month',
};
export const SEARCH_BALANCE_BY_PERIOD = {
  hour: 'api/eu/v1/TimeSeries/Balance/search-by-hour',
  date: 'api/eu/v1/TimeSeries/Balance/search-by-date',
  month: 'api/eu/v1/TimeSeries/Balance/search-by-month',
};
export const SET_TIME_SERIES_VIEW = 'api/eu/v1/TimeSeries/View/set';
export const DELETE_TIME_SERIES_VIEW = 'api/eu/v1/TimeSeries/View/delete';
export const GET_CONTRACTS = 'api/eu/v1/Contract/get';
export const GET_CONTRACT_TYPES = 'api/eu/v1/ContractType/get';
export const GET_LOCATIONS = 'api/eu/v1/Location/get';
export const GET_ORGANIZATIONS = 'api/eu/v1/Organization/get';
export const GET_ORGANIZATION_ROLES = 'api/eu/v1/Organization/get-roles';
export const SET_MARKET = 'api/eu/v1/Market/set';
export const SET_LOCATION = 'api/eu/v1/Location/set';
export const SET_ORGANIZATION = 'api/eu/v1/Organization/set';
export const SET_NOMINATION_GROUP = 'api/eu/v1/NominationGroup/set';
export const SET_CONTRACT = 'api/eu/v1/Contract/set';
export const GET_PARAMETER_DEFINITIONS = 'api/eu/v1/parameter/get';
export const GET_JOBS = 'api/eu/v1/Job/get';
export const SET_JOB = 'api/eu/v1/Job/set';
export const GET_JOB_PERIODS = 'api/eu/v1/Job/get-periods';
export const GET_JOB_MESSAGE_TYPES = 'api/eu/v1/Job/get-message-types';
export const GET_TIME_SERIES_VOLUME_TYPES = 'api/eu/v1/TimeSeries/get-volume-types';
export const GET_FLOWS = 'api/eu/v1/Flow/get';
export const GET_EDITOR_REFERENCE_DATA = 'api/eu/v1/Flow/get-editor-reference-data';
export const SET_FLOW = 'api/eu/v1/Flow/set';
export const MAX_LENGTH_50 = 50;
export const MAX_LENGTH_20 = 20;

export enum ParameterScope {
  Organization = 1,
  NominationGroup = 2,
  Location = 3,
  Contract = 4,
  Position = 5,
  JobOutgoingDNSCP = 6,
  JobIncomingDNSCP = 7,
  JobOutgoingAVAILY = 8,
  JobIncomingAVAILY = 9,
}

export const getParameterDefinitionsUrl = (scopeId: ParameterScope) =>
  `${GET_PARAMETER_DEFINITIONS}?scopeId=${scopeId}`;

export const MESSAGES = {
  SERVER_ERROR: 'Something went wrong please contact system administrator.',
  CREATED_MARKET: 'Market created successfully.',
  UPDATED_MARKET: 'Market updated successfully.',
  CREATED_MARKET_FAILED: 'Failed to create the market.',
  UPDATED_MARKET_FAILED: 'Failed to update the market.',
  REQUIRED_MARKET_NAME: 'Market name is required.',
  REQUIRED_SHORT_NAME: 'Short name is required.',
  REQUIRED_MARKET_TYPE: 'Market type is required.',
  REQUIRED_BALANCE: 'At least one balance is required.',
  REQUIRED_BALANCE_NAME: 'Balance is required.',
  REQUIRED_INTERNAL_ENTITY: 'Internal entity is required.',
  REQUIRED_VALID_TO: 'Valid to is required.',
  COMPLETE_BALANCE_BEFORE_ADDING: 'Complete or cancel the current balance before adding another.',
  BALANCE_DATE_OUTSIDE_MARKET_RANGE:
    'Balance validity dates must be within the market validity period.',
  MAX_LENGTH_50: 'Maximum 50 characters are allowed.',
  MAX_LENGTH_20: 'Maximum 20 characters are allowed.',
  CREATED_LOCATION: 'Location created successfully.',
  UPDATED_LOCATION: 'Location updated successfully.',
  CREATED_LOCATION_FAILED: 'Failed to create the location.',
  UPDATED_LOCATION_FAILED: 'Failed to update the location.',
  REQUIRED_LOCATION_NAME: 'Location name is required.',
  REQUIRED_LOCATION_TYPE: 'Location type is required.',
  REQUIRED_ORGANIZATION: 'Organization is required.',
  REQUIRED_PARAMETER_DEFINITION: 'Parameter name is required.',
  COMPLETE_PARAMETER_BEFORE_ADDING:
    'Complete or cancel the current parameter before adding another.',
  REQUIRED_PARAMETER_VALUE: 'Parameter value is required.',
  UNRESOLVED_PARAMETER_DEFINITION:
    'Unable to identify this saved parameter. Refresh the contract and try again.',
  REQUIRED_VALID_FROM: 'Valid from is required.',
  SAVED_JOB: 'Job saved successfully.',
  SAVED_JOB_FAILED: 'Failed to save the job.',
  INVALID_PARAMETER_DATE_RANGE: 'Valid to must be on or after valid from.',
  PARAMETER_DATE_OUTSIDE_LOCATION_RANGE:
    'Parameter validity dates must be within the location validity period.',
  PARAMETER_DATE_OUTSIDE_ORGANIZATION_RANGE:
    'Parameter validity dates must be within the organization validity period.',
  PARAMETER_DATE_OUTSIDE_NOMINATION_GROUP_RANGE:
    'Parameter validity dates must be within the nomination group validity period.',
  PARAMETER_DATE_OUTSIDE_CONTRACT_RANGE:
    'Parameter validity dates must be within the contract validity period.',
  PARAMETER_DATE_OUTSIDE_POSITION_RANGE:
    'Parameter validity dates must be within the position validity period.',
  POSITION_DATE_OUTSIDE_CONTRACT_RANGE:
    'Position validity dates must be within the contract validity period.',
  OVERLAPPING_PARAMETER_DATE_RANGE:
    'Parameter validity dates cannot overlap for the same parameter.',
  INVALID_WHOLE_NUMBER: 'Enter a whole number.',
  INVALID_DECIMAL_NUMBER: 'Enter a valid decimal number.',
  CREATED_ORGANIZATION: 'Organization created successfully.',
  UPDATED_ORGANIZATION: 'Organization updated successfully.',
  CREATED_ORGANIZATION_FAILED: 'Failed to create the organization.',
  UPDATED_ORGANIZATION_FAILED: 'Failed to update the organization.',
  REQUIRED_ORGANIZATION_NAME: 'Organization name is required.',
  REQUIRED_ROLE: 'At least one role must be assigned.',
  CREATED_NOMINATION_GROUP: 'Nomination group created successfully.',
  UPDATED_NOMINATION_GROUP: 'Nomination group updated successfully.',
  CREATED_NOMINATION_GROUP_FAILED: 'Failed to create the nomination group.',
  UPDATED_NOMINATION_GROUP_FAILED: 'Failed to update the nomination group.',
  REQUIRED_NOMINATION_GROUP_NAME: 'Nomination group name is required.',
  REQUIRED_ALIAS_NAME: 'Alias name is required.',
  REQUIRED_INTERNAL_ORGANIZATION: 'Internal organization is required.',
  REQUIRED_EXTERNAL_ORGANIZATION: 'External organization is required.',
  CREATED_CONTRACT: 'Contract created successfully.',
  UPDATED_CONTRACT: 'Contract updated successfully.',
  CREATED_CONTRACT_FAILED: 'Failed to create the contract.',
  UPDATED_CONTRACT_FAILED: 'Failed to update the contract.',
  REQUIRED_CONTRACT_NAME: 'Contract name is required.',
  REQUIRED_CONTRACT_TYPE: 'Contract type is required.',
  REQUIRED_INTERNAL_LEGAL_ENTITY: 'Internal legal entity is required.',
  REQUIRED_EXTERNAL_LEGAL_ENTITY: 'External legal entity is required.',
  REQUIRED_POSITION: 'At least one position is required.',
  REQUIRED_POSITION_NAME: 'Position name is required.',
  REQUIRED_NOMINATION_GROUP: 'Nomination group is required.',
  REQUIRED_DIRECTION: 'Direction is required.',
  REQUIRED_MAPPING_KEY: 'Mapping key is required.',
  CREATED_FLOW: 'Flow created successfully.',
  UPDATED_FLOW: 'Flow updated successfully.',
  CREATED_FLOW_FAILED: 'Failed to create the flow.',
  UPDATED_FLOW_FAILED: 'Failed to update the flow.',
  REQUIRED_FLOW_NAME: 'Flow name is required.',
  REQUIRED_SOURCE: 'Source is required.',
  REQUIRED_BLOB_PATH_PATTERN: 'Blob path pattern is required.',
  REQUIRED_STEP_NAME: 'Step name is required.',
  REQUIRED_ACTIVITY: 'Activity is required.',
  REQUIRED_FLOW_STEP: 'At least one processing step is required.',
  REQUIRED_XSLT_DEFINITION: 'XSLT definition content is required for an XSLT Transformer step.',
  NO_FLOWS_FOR_SOURCE: 'No flows are configured for the selected source.',
  COPIED_XSLT_DEFINITION: 'XSLT definition copied to clipboard.',
  COPY_XSLT_DEFINITION_FAILED: 'Unable to copy the XSLT definition.',
};
